// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"299":"c05d36c8","946":"436d35bd"}[chunkId] + ".js";
};